import { render } from "./ReceiversAutocompleteSuggestionsHeader.vue?vue&type=template&id=fe9432f0"
const script = {}

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__